import { useMemo } from 'react';
import { useRegisterMenuFilters } from '../context/FilterBridgeContext';

export function useMenuFilterRegistration(active, options) {
  const {
    wsStatus,
    wsLabel,
    lastWsLabel,
    onReconnect,
    showReconnect = true,
    reconnectLabel = 'Reconnect WS',
    hint,
    closed,
    loading,
    extras = null,
    menuToolbar = null,
    pageTitle,
    error,
  } = options;

  const filterConfig = useMemo(
    () => ({
      wsStatus,
      wsLabel,
      lastWsLabel,
      hint,
      closed,
      showReconnect,
      reconnectLabel,
      onReconnect,
      extras,
      menuToolbar,
      pageTitle,
      error,
      loading,
    }),
    [
      wsStatus,
      wsLabel,
      lastWsLabel,
      hint,
      closed,
      showReconnect,
      reconnectLabel,
      onReconnect,
      extras,
      menuToolbar,
      pageTitle,
      error,
      loading,
    ]
  );

  useRegisterMenuFilters(active, filterConfig);
}
